<template>
    <section class="offline-container">
        <div class="img">
            <img :src="offlineImg">
        </div>
        <div class="message">
            <h1>Sem conexão com a internet</h1>
            <h2>Verifique sua conexão e tente novamente.</h2>
        </div>
        <div class="btn">
            <ButtonCenter :button="button" @click="button.action && button.action()"></ButtonCenter>
        </div>
    </section>
</template>
<script >
import ButtonCenter from '../components/buttons/center/ButtonCenter.vue'
import router from '@/router/index.js'
export default {
    name: 'OffLineView',
    components: { ButtonCenter },
    data () {
        return {
            offlineImg: require('@/assets/default/icons/offline.png'),
            button: {
                display: 'Atualizar',
                fill: true,
                action: this.update
            }
        }
    },
    methods: {
        update: function () {
            const online = window.navigator.onLine
            if (online) {
                router.back()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.offline-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    height: 100vh;
    .img {
        padding: 20px;
        img {
            width: 100px;
            height: 100px;
        }
    }
    .message {
        text-align: center;
        padding-bottom: 20px;
        h1 {
            font-size: 2ch;
            font-weight: bold;
            padding-bottom: 10px;
        }
        h2 {
            font-size: 1.5ch;
        }
    }
    .btn {
        width: 60%;
        margin: 20px;
    }
}
</style>
